import React, { createContext, useContext } from 'react';
import { EducationFilterConfig } from 'talent_matching/types';

export const TABS = {
  APP_REVIEW: 'app-review',
  REDISCOVERY: 'rediscovery',
  MY_GREENHOUSE: 'mygreenhouse',
} as const;

export type TabKey = typeof TABS[keyof typeof TABS];

export interface UserContextValue {
  calibrationTerms: string[];
  canCreateTags: boolean;
  canCreateSources: boolean;
  canExport: boolean;
  canUseLocations: boolean;
  isSiteAdmin: boolean;
  userDateFormat: string;
  linkedinRscEnabled: boolean;
  canUseSecurityConcerns: boolean;
  userId: number;
  currentUserName: string;
  hiringPlanId: number;
  hiringPlanName: string;
  activeTab: TabKey;
  educationFilterConfig: EducationFilterConfig;
  paths: {
    getTagsPath: string;
    savedSearchesPath: string;
  };
}

const UserContext = createContext<UserContextValue | undefined>(undefined);

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext not used within a UserContext.Provider');
  }
  return context;
};

type UserContextProviderProps = {
  value: UserContextValue;
  children: React.ReactNode;
};

export const UserContextProvider = ({
  value,
  children,
}: UserContextProviderProps) => {
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
